<!--
	TEMPLATE
-->
<template>

	<div class="editable-item mdc-layout-grid__inner" :class="{'editable-item--enabled': isEditView}">
		<!-- Title -->
	   <div v-if="!isEditView" @click.prevent="edit()" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title" :class="{ 'editable-item__editing': isEditView }">
			<div class="editable-item__centered"><span>{{title}}</span></div>
		</div>
		<!-- Back Button -->
		<div v-if="isEditView" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone editable-item__title editable-item__back-btn" :class="{ 'editable-item__editing': isEditView }">
			<div class="editable-item__centered"></div>
		</div>
		<!-- Component -->
		<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone editable-item__middle-cell">
			<component :is="component" v-model="nestedModel" :isEditView="isEditView" :options="options" @changed="changed" @hasErrors="errors(arguments[0])" class="editable-item__centered editable-item__content"></component>
			<div v-if="isEditView" class="editable-item__btn-wrapper">
				<!-- Cancel Button -->
				<button class="mdc-button editable-item__cancel-btn" @click="back">Cancel</button>
				<!-- Save Button -->
				<button :disabled="hasErrors" class="mdc-button" @click="save">Save</button>
			</div>
		</div>
		<!-- Edit Button -->
		<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-1 mdc-layout-grid__cell--span-1-phone editable-item__edit" @click.prevent="edit($event)">
      	<div class="editable-item__edit-btn" v-if="!isEditView && !hasErrors"><a href="#"><i class="ico-edit"></i></a></div>
			<div class="editable-item__edit-btn" v-if="!isEditView && hasErrors"><a href="#"><i class="ico-attention message--error"></i></a></div>
    	</div>
		<!-- Divider -->
		<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
			<hr>
		</div>
	</div>

</template>

<!--
	SCRIPT
-->
<script>
import vModelNested from '@/libs/vModelNested.js';
import EditableText from './EditableText.vue';
import EditablePrice from './EditablePrice.vue';
import EditableOptions from './EditableOptions.vue';
import EditableCheckboxes from './EditableCheckboxes.vue';
import EditablePhotos from './EditablePhotos.vue';
import EditableEPC from './EditableEPC.vue';
import EditableBrochure from './EditableBrochure.vue';
import EditableAddress from './EditableAddress.vue';
import EditableRooms from './EditableRooms.vue';
import EditableRepeatableInputs from './EditableRepeatableInputs.vue';
import EditableInput from './EditableInput.vue';
import EditableImage from './EditableImage.vue';

export default {
	props: ['value','component','title', 'options'],
	data: function() {
		return {
			isEditView: true,
			hasErrors: false
		}
	},
	computed: {
		nestedModel: vModelNested
	},
	components: {
		'editable-text': EditableText,
		'editable-price': EditablePrice,
		'editable-options': EditableOptions,
		'editable-checkboxes': EditableCheckboxes,
		'editable-photos': EditablePhotos,
		'editable-epc': EditableEPC,
		'editable-brochure': EditableBrochure,
		'editable-repeatable-inputs': EditableRepeatableInputs,
		'editable-input': EditableInput,
		'editable-address': EditableAddress,
		'editable-rooms': EditableRooms,
		'editable-image': EditableImage
	},
	watch: {
		isEditView: function() {
			this.$emit('isEditView', this.isEditView)
		}
	},
	methods: {
		edit: function(e) {
			// Check if div.editable-item has class .text-inactive
			if(!e.target.parentNode.parentNode.parentNode.parentNode.classList.contains('text-inactive')) {
				this.isEditView = true;
			}
		},
		back: function() {
			this.isEditView = false
			this.$emit('back')
		},
		save: function() {
			//this.isEditView = false
			this.$emit('changed')
			this.$emit('update')
		},
		changed: function() {
			this.$emit('changed');
		},
		errors: function(errors) {
			this.hasErrors = errors;
			this.$emit('hasErrors', errors);
		}
	}
}
</script>
